// extracted by mini-css-extract-plugin
export var indeterminate = "_1w-5";
export var md = "_1w-4";
export var semantic = "_1w-6";
export var sm = "_1w-3";
export var text = "_1w-7";
export var toggleInput = "_1w-0";
export var toggleSwitch = "_1w-1";
export var xs = "_1w-2";